import { z } from "zod";
import { ApiError } from "@altek/ui/lib/problem";
import { newPasswordSchema } from "@/features/auth/components/PasswordReset.schema";

/**
 * Kişinin kendi parolasını değiştirmesi — sunucudaki `changePasswordSchema` ile birebir (31 Ekim 2026). İki ekran
 * kullanıyor: ilk girişteki zorunlu değiştirme (`PasswordChangeRequired`) ve Profil › «Parola». Yeni parola eskisiyle
 * aynı olamaz (sunucu da 400 veriyor).
 */
export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "Şu anki parolanızı yazın.").max(200),
    newPassword: newPasswordSchema,
  })
  .refine((values) => values.newPassword !== values.currentPassword, {
    path: ["newPassword"],
    message: "Yeni parola eskisinden farklı olmalı.",
  });

export type ChangePasswordValues = z.infer<typeof changePasswordSchema>;

/** Yanlış yazılan şu anki parola: bir oturum olayı değil (`client.ts`), alanın altında söylenir. */
export function isWrongCurrentPassword(error: unknown): boolean {
  return error instanceof ApiError && error.code === "INVALID_CREDENTIALS";
}
